import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaUsoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('inputDate-fechaAdquisicion', e, {
      timeOutTime: 200
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC USO' htmlFor='inputDate-fechaUso' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='fechaUso'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='inputDate-fechaUso'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaUsoFormGroup)
